/**
 * TutorTips type definitions
 * Implements US-001 / T-types / API-001 contract.
 * Config served by GET /system-config/tutor-tips (deployed in TS-007).
 */

/**
 * Response shape from GET /system-config/tutor-tips (API-001).
 * The client only reads tipPopupCountdownSeconds; all other fields are backend-internal.
 */
export interface TutorTipsConfig {
  /** Seconds the "I understand" button stays disabled. Default 4; product convention 3–5. */
  tipPopupCountdownSeconds: number;
}

/**
 * Client fallback when the endpoint fails or returns an out-of-range value (API-001).
 * If the config fetch fails the session is never blocked — we fall back to this constant.
 */
export const DEFAULT_TIP_COUNTDOWN_SECONDS = 4;
